import { postMyPlayer, deleteMyPlayer } from '@/api/endpoints';
import { Player, AppUser } from '@/api/models';
import { MyPlayerDB } from '@/db/repositories';
import MyPlayer from '@/db/models/MyPlayerModel';
import { IActivePlayer } from '@/db/repositories/ActivePlayerRepo';
import { onlineStatus } from '@/utils';

const transformToMyPlayer = (player: IActivePlayer | Player): MyPlayer => ({
  playerId: player.playerId,
  firstName: player.firstName,
  lastName: player.lastName,
  fullName: player.fullName,
});

export const saveMyPlayers = async (appUser: AppUser) => {
  try {
    const myPlayers = appUser.myPlayers.map(transformToMyPlayer);
    await MyPlayerDB.bulkAdd(myPlayers);
  } catch (error) {
    console.error('Failed to sync getUserWithMyPlayers from API:', error);
    // TODO: Save error to ErrorLogRepo
  }
};

export const getMyPlayers = async () => {
  const myPlayers = await MyPlayerDB.list();
  return myPlayers;
};

export const addMyPlayer = async (player: IActivePlayer) => {
  const isOnline = onlineStatus.get();
  const myPlayer: MyPlayer = transformToMyPlayer(player);
  if (isOnline) {
    await postMyPlayer(player.playerId);
    await MyPlayerDB.add(myPlayer);
  } else {
    // TODO: Handle API failure
    await MyPlayerDB.add(myPlayer);
  }
};

export const removeMyPlayer = async (player: IActivePlayer) => {
  const isOnline = onlineStatus.get();
  if (isOnline) {
    await deleteMyPlayer(player.playerId);
    await MyPlayerDB.delete(player.playerId);
  } else {
    // TODO: Handle API failure
    await MyPlayerDB.delete(player.playerId);
  }
};
